module.exports = __webpack_public_path__ + "static/media/39@2x.02a33250.png";